import Vue from 'vue'
let observer = null
const option = {
  threshold: 0.5
}
let initialized = false

function setObserber(el) {
  //console.log(' intersection observer set init[%s] %O', initialized, el)
  if (initialized) {
    observer.observe(el)
  } else {
    setTimeout(setObserber, 500, el)
  }
}

Vue.directive('intersection', {
  inserted(el, binding) {
    if (!!binding.value && !!binding.value.alternate) el.dataset.alternate = true
    if (!observer) {
      window.addEventListener('load', () => (initialized = true))
      observer = new IntersectionObserver(entries => {
        intersectionCallback(entries)
      }, option)
    }

    // observer.observe(el)
    setObserber(el)
  }
})

function intersectionCallback(entries) {
  for (const e of entries) {
    // const force = window.innerHeight < e.target.clientHeight ? e.intersectionRatio > 0 : false
    if (e.isIntersecting) {
      e.target.classList.add('intersecting')
    } else {
      if (!!e.target.dataset.alternate) e.target.classList.remove('intersecting')
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/directive/intersection.js